import React from "react";
import { shortDateFormat } from "../../utilities/utilities";
import { nullsLastSort } from "./SortableTable";

// shared tabsFilterMap for tag/list-style tables (client tags, matter tags, office/branch, etc.)
export const activeStatusTabFilterMap = {
	Active: (row) => row.status === "active",
	Inactive: (row) => row.status === "inactive",
	Custom: (row) => row.createdBy !== "LexWorkplace",
	All: () => true,
};

export const statusColumn = {
	Header: "Status",
	accessor: "status",
	Cell: (row) => (
		<span style={{ textTransform: "capitalize" }}>{row.value}</span>
	),
};

export const lastModifiedColumn = {
	Header: "Last Modified",
	accessor: "lastUpdated",
	Cell: (row) => (row.value ? shortDateFormat(row.value) : ""),
	filterValueMethod: (x) => shortDateFormat(x.lastUpdated),
	sortingFn: nullsLastSort,
};
